// @ts-nocheck
// TODO: tighten types after migration
import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useRegion } from "../context/RegionContext";
import "./AllProducts.css";
import { NavLink } from 'react-router-dom';
import { API_ENDPOINTS } from '../config/api';
import { fetchHygraphProduct } from "./hygraphService";
import SidebarAd from "../Blog/SidebarAd";
import LogoLoader from "../components/LogoLoader";
import PaginationControls from "../components/ui/PaginationControls";



function Design(props){
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const productType = props.productType || 'physical';
    
    // Handle both image formats: objects with url/altText and simple strings
    let imageUrl = '';
    let imageAlt = props.title;
    
    // Priority for digital products: displayImage first, then Hygraph images, then MongoDB images
    // For physical products: Hygraph images first, then MongoDB images (never use displayImage)
    let imagesToUse = [];
    if (productType === 'digital') {
        // Digital products: prioritize displayImage
        if (props.displayImage && Array.isArray(props.displayImage) && props.displayImage.length > 0) {
            imagesToUse = props.displayImage;
        } else if (props.hygraphImages && Array.isArray(props.hygraphImages) && props.hygraphImages.length > 0) {
            imagesToUse = props.hygraphImages;
        } else if (props.images && Array.isArray(props.images) && props.images.length > 0) {
            imagesToUse = props.images;
        }
    } else {
        // Physical products: never use displayImage
        if (props.hygraphImages && Array.isArray(props.hygraphImages) && props.hygraphImages.length > 0) {
            imagesToUse = props.hygraphImages;
        } else if (props.images && Array.isArray(props.images) && props.images.length > 0) {
            imagesToUse = props.images;
        }
    }
    
    if (imagesToUse && imagesToUse.length > 0) {
        const currentImage = imagesToUse[currentImageIndex];
        if (typeof currentImage === 'string') {
            // If image is a simple string URL
            imageUrl = currentImage;
        } else if (currentImage && typeof currentImage === 'object') {
            // If image is an object with url and altText
            imageUrl = currentImage.url || '';
            imageAlt = currentImage.altText || props.title;
        }
    }

    const handlePrevious = (e) => {
        e.preventDefault(); // Prevent navigation to product page
        if (imagesToUse && imagesToUse.length > 1) {
            setCurrentImageIndex(prev => 
                prev === 0 ? imagesToUse.length - 1 : prev - 1
            );
        }
    };

    const handleNext = (e) => {
        e.preventDefault(); // Prevent navigation to product page
        if (imagesToUse && imagesToUse.length > 1) {
            setCurrentImageIndex(prev => 
                prev === imagesToUse.length - 1 ? 0 : prev + 1
            );
        }
    };

    // Calculate discount percentage
    const calculateDiscount = () => {
        if (props.offerPrice && props.offerPrice !== props.price) {
            const discount = ((props.price - props.offerPrice) / props.price) * 100;
            return Math.round(discount);
        }
        return 0;
    };

    const discountPercentage = calculateDiscount();
    
    return(
        <div className="product-card-wrapper flex w-full flex-col overflow-hidden rounded-[25px] border-[4px] border-slider bg-bg box-border transition-colors duration-200 hover:border-primary-cyan">
            <NavLink key={props.id} to={`/store/${props.slug}`} className="product-card flex h-full flex-1 flex-col text-inherit no-underline">
                <div className="product-image-container relative flex w-full items-center justify-center overflow-hidden bg-[#f8f9fa] [aspect-ratio:1/1]">
                    {imageUrl ? (
                        <img
                            className="image block h-full w-full object-cover"
                            src={imageUrl}
                            alt={imageAlt}
                            loading="lazy"
                            decoding="async"
                        />
                    ) : (
                        <div className="no-image flex h-full w-full items-center justify-center border-b border-[#eee] bg-[#f8f9fa] text-[1.1rem] text-[#6c757d]">No Image</div>
                    )}
                    
                    {/* Image navigation arrows - only show if there are multiple images */}
                    {imagesToUse && imagesToUse.length > 1 && (
                        <div className="product-image-nav absolute bottom-[10px] right-[10px] z-[10] flex gap-[5px]">
                            <button 
                                className="product-nav-btn product-nav-prev flex h-[32px] w-[32px] items-center justify-center rounded-[10px] border border-slider bg-white/90 text-[#333] text-[12px] transition-all duration-300 hover:scale-110 hover:bg-white active:scale-95"
                                onClick={handlePrevious}
                                aria-label="Previous image"
                            >
                                <i className="fi fi-rr-caret-left text-[14px] leading-none"></i>
                            </button>
                            <button 
                                className="product-nav-btn product-nav-next flex h-[32px] w-[32px] items-center justify-center rounded-[10px] border border-slider bg-white/90 text-[#333] text-[12px] transition-all duration-300 hover:scale-110 hover:bg-white active:scale-95"
                                onClick={handleNext}
                                aria-label="Next image"
                            >
                                <i className="fi fi-rr-caret-right text-[14px] leading-none"></i>
                            </button>
                        </div>
                    )}
                </div>
                <div className="Heading grow px-[1rem] pt-[1rem] pb-[0.25rem]">
                    <p className="title m-0 mb-[0.5rem] text-[1.1rem] font-[600] leading-[1.4] text-text">{props.title}</p>
                </div>
                <div className="price-container mb-[2px] flex items-center gap-[10px] px-[15px] pt-[2px] pb-[15px]">
                    {props.offerPrice && props.offerPrice !== props.price && discountPercentage >= 5 ? (
                        <>
                            <p className="price m-0 inline-block p-0 text-[1.4rem] font-[700] text-post-heading">{props.currencySymbol || '₹'}{props.offerPrice.toLocaleString()}</p>
                            <p className="original-price-container m-0 inline-block text-[0.85em] font-[500] text-[#999]">
                                <span className="original-price line-through">{props.currencySymbol || '₹'}{props.price.toLocaleString()}</span>
                                <span className="discount-percentage text-[0.95em]"> ({discountPercentage}% OFF)</span>
                            </p>
                        </>
                    ) : (
                        <p className="price m-0 inline-block p-0 text-[1.4rem] font-[700] text-post-heading">{props.currencySymbol || '₹'}{(props.offerPrice || props.price).toLocaleString()}</p>
                    )}
                </div>
            </NavLink>
            
            {/* Action buttons */}
            <div className="product-actions mt-auto flex justify-end gap-[10px] px-[15px] py-[10px]">
                <button 
                    className="buy-now-btn rounded-[6px] border-none bg-primary-cyan px-[20px] py-[10px] text-[0.9rem] font-[600] text-white"
                    onClick={(e) => {
                        e.preventDefault();
                        window.location.href = `/store/${props.slug}`;
                    }}
                >
                    Buy Now
                </button>
            </div>
        </div>
    )
}



export default function AllProducts(){
    const [products, setProducts] = useState([]);
    const [hygraphData, setHygraphData] = useState({});
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [selectedProductType, setSelectedProductType] = useState('digital'); // Default to digital
    const [currentPage, setCurrentPage] = useState(1);
    const productsPerPage = 12;

    // Search and Sort State
    const [searchQuery, setSearchQuery] = useState("");
    const [searchFocused, setSearchFocused] = useState(false);
    const [sortBy, setSortBy] = useState("name"); // "name"
    const [sortOrder, setSortOrder] = useState("asc"); // "asc" | "desc"
    const [viewType, setViewType] = useState("all"); // "all" | "category"
    const [selectedCategory, setSelectedCategory] = useState("");

    const { state } = useLocation();

    useEffect(() => {
        if (state && state.selectedCategory) {
            setViewType("category");
            let catName = "";
            if (typeof state.selectedCategory === 'string') catName = state.selectedCategory;
            else if (state.selectedCategory.name) catName = state.selectedCategory.name;
            
            if (catName) {
                setSelectedCategory(catName);
                setCurrentPage(1);
            }
        }
    }, [state]);

    // Logo Loader State
    const [showLoader, setShowLoader] = useState(true);
    const [loadingProgress, setLoadingProgress] = useState(0);

    // Loading Simulation
    useEffect(() => {
        let progress = 0;
        const interval = setInterval(() => {
            // If fetching is still active, cap at 90%
            const maxProgress = loading ? 90 : 100;
            
            // Increment logic
            if (progress < maxProgress) {
                const increment = Math.random() * 10;
                progress = Math.min(progress + increment, maxProgress);
                setLoadingProgress(progress);
            }

            // Completion check
            if (!loading && progress >= 100) {
                clearInterval(interval);
                setTimeout(() => setShowLoader(false), 500);
            }
        }, 100);

        return () => clearInterval(interval);
    }, [loading]);

    const { selectedCountry } = useRegion();

    useEffect(() => {
        const fetchProducts = async () => {
            try {
                setLoading(true);
                
                // Append country parameter to API URL
                const baseUrl = API_ENDPOINTS.STORE.PRODUCTS;
                const separator = baseUrl.includes('?') ? '&' : '?';
                const url = `${baseUrl}${separator}country=${selectedCountry || 'IN'}`;
                
                const response = await fetch(url);

                // Safe JSON parse — guards against Render.com cold-start returning "undefined"
                let data;
                try {
                    const rawText = await response.text();
                    const trimmed = rawText ? rawText.trim() : '';
                    if (!trimmed || trimmed === 'undefined' || trimmed === 'null') {
                        setError('Server returned an empty response. Please refresh.');
                        return;
                    }
                    data = JSON.parse(trimmed);
                } catch (parseErr) {
                    console.error('[AllProducts] Failed to parse response:', parseErr);
                    setError('Failed to load products. Please refresh.');
                    return;
                }

                if (data.success) {
                    setProducts(data.data);
                    
                    // Fetch Hygraph data for each product
                    const hygraphDataMap = {};
                    for (const product of data.data) {
                        const slug = product.slug || (product.title && product.title.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, ''));
                        if (slug) {
                            const hygraphProduct = await fetchHygraphProduct(slug);
                            if (hygraphProduct) {
                                hygraphDataMap[product._id] = hygraphProduct;
                            }
                        }
                    }
                    setHygraphData(hygraphDataMap);
                } else {
                    setError(data.message || 'Failed to fetch products');
                }
            } catch (err) {
                setError('Failed to fetch products');
                console.error('Error fetching products:', err);
            } finally {
                setLoading(false);
            }
        };

        if (selectedCountry) {
            fetchProducts();
        }
    }, [selectedCountry]);

    // Reset to page 1 when product type or search/filter changes
    useEffect(() => {
        setCurrentPage(1);
    }, [selectedProductType, searchQuery, sortBy, sortOrder, viewType, selectedCategory]);

    // Extract unique categories
    const uniqueCategories = React.useMemo(() => {
        const cats = new Set();
        products.forEach(p => {
            if (p.category) cats.add(p.category);
        });
        return Array.from(cats).sort();
    }, [products]);

    // Filter products based on selected product type, search query, and category
    const filteredProducts = products.filter(product => {
        // Get productType from the product, defaulting to 'physical' if not specified
        const productType = (product.productType && product.productType.toLowerCase()) || 'physical';
        const typeMatch = productType === selectedProductType.toLowerCase();
        
        const searchMatch = !searchQuery.trim() || product.title.toLowerCase().includes(searchQuery.toLowerCase().trim());
        
        const categoryMatch = viewType === 'all' || !selectedCategory || product.category === selectedCategory;

        return typeMatch && searchMatch && categoryMatch;
    });

    // Sort products
    filteredProducts.sort((a, b) => {
        if (sortBy === "name") {
            const nameA = a.title || "";
            const nameB = b.title || "";
            return sortOrder === "asc" 
                ? nameA.localeCompare(nameB) 
                : nameB.localeCompare(nameA);
        }
        return 0;
    });

    if(showLoader) return <LogoLoader progress={loadingProgress} />;
    
    if(error) return <div className="error-message mx-auto my-[2rem] w-[95%] max-w-[1200px] rounded-[15px] border border-red-300 bg-red-50 p-[1rem] text-center text-red-700">Error: {error}</div>;

    // Empty state for All Products page
    if (!loading && !error && products.length === 0) {
        return (
            <div className="flex h-[50vh] items-center justify-center text-center text-[1.1rem]">
                Products are yet to be added
            </div>
        );
    }

    // Calculate pagination
    const totalPages = Math.ceil(filteredProducts.length / productsPerPage);
    const startIndex = (currentPage - 1) * productsPerPage;
    const endIndex = startIndex + productsPerPage;
    const currentProducts = filteredProducts.slice(startIndex, endIndex);

    const all_products = currentProducts.map((product) => {
        // Generate slug from title if not available
        const slug = product.slug || (product.title && product.title.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, ''));
        
        return(
            <Design
                key={product._id}
                id={product._id}
                title={product.title}
                price={product.price}
                offerPrice={product.offerPrice}
                images={product.images}
                displayImage={product.displayImage}
                hygraphImages={hygraphData[product._id] && hygraphData[product._id].productImages}
                slug={slug}
                productType={product.productType || 'physical'}
                currencySymbol={product.currencySymbol || '₹'}
            />
        )
    });

    return(
        <>
            <div className="store-top-section w-full flex flex-col">
                <div className="store-filters-content w-full max-w-[1200px] mx-auto">
                    {/* Segmented Control for Product Type Filter */}
                    <div className="product-type-filter flex items-center justify-center px-[1rem] pt-[3rem] pb-[1rem] max-w-[1200px] mx-auto max-[767px]:px-[1rem] max-[767px]:pt-[1.5rem] max-[767px]:pb-[1rem] max-[480px]:px-[0.5rem] max-[480px]:pt-[1rem] max-[480px]:pb-[0.5rem]">
                        <div className="segmented-control inline-flex min-w-[300px] gap-[5px] rounded-[25px] border border-slider bg-bg p-[4px] max-[767px]:min-w-[250px] max-[767px]:w-full max-[767px]:max-w-[400px] max-[480px]:min-w-[200px] max-[480px]:max-w-full">
                            <button
                                className={`segment-btn relative z-[1] flex-1 whitespace-nowrap rounded-[20px] border-none px-[32px] py-[12px] text-[14px] font-[700] uppercase tracking-[0.5px] transition-all duration-300 max-[767px]:px-[20px] max-[767px]:py-[10px] max-[767px]:text-[12px] max-[480px]:px-[16px] max-[480px]:py-[8px] max-[480px]:text-[11px] ${selectedProductType === 'digital' ? 'active bg-primary-cyan text-white' : 'bg-bg text-text hover:bg-hover'}`}
                                onClick={() => setSelectedProductType('digital')}
                            >
                                DIGITAL
                            </button>
                            <button
                                className={`segment-btn relative z-[1] flex-1 whitespace-nowrap rounded-[20px] border-none px-[32px] py-[12px] text-[14px] font-[700] uppercase tracking-[0.5px] transition-all duration-300 max-[767px]:px-[20px] max-[767px]:py-[10px] max-[767px]:text-[12px] max-[480px]:px-[16px] max-[480px]:py-[8px] max-[480px]:text-[11px] ${selectedProductType === 'physical' ? 'active bg-primary-cyan text-white' : 'bg-bg text-text hover:bg-hover'}`}
                                onClick={() => setSelectedProductType('physical')}
                            >
                                PHYSICAL
                            </button>
                        </div>
                    </div>

                    {/* Store Search and Filters */}
                    <div className="store-header-filters mx-auto my-[1rem] mb-[2rem] flex w-full max-w-[1200px] flex-col items-center gap-[15px] px-[1.5rem] box-border">
                        <div className={`store-search-wrapper relative w-full max-w-[1000px] ${searchFocused ? "is-focused" : ""}`}>
                            <div className={`store-search-inner flex w-full items-center gap-[10px] rounded-[50px] border-2 bg-bg px-[20px] py-[12px] transition-all duration-300 box-border ${searchFocused ? 'border-primary-cyan shadow-[0_0_15px_rgba(71,181,255,0.15)]' : 'border-slider'}`}>
                                <i className="fi fi-rr-search text-[1.1rem] text-[#888] shrink-0 leading-none flex items-center"></i>
                                <span className="store-search-sep h-[20px] w-[1px] shrink-0 bg-[#555]"></span>
                                <input
                                    type="text"
                                    className="store-search-input min-w-0 flex-1 border-none bg-transparent p-0 text-[1rem] text-text outline-none"
                                    placeholder="Search products..."
                                    value={searchQuery}
                                    onChange={(e) => setSearchQuery(e.target.value)}
                                    onFocus={() => setSearchFocused(true)}
                                    onBlur={() => setSearchFocused(false)}
                                />
                                {searchQuery && (
                                    <button
                                        className="store-search-clear flex items-center justify-center rounded-full border-none bg-transparent p-[5px] text-[#888] transition-colors duration-200 hover:bg-black/5 hover:text-[#555]"
                                        onClick={() => setSearchQuery("")}
                                        aria-label="Clear search"
                                    >
                                        <i className="fi fi-rr-cross-small"></i>
                                    </button>
                                )}
                            </div>
                        </div>

                        <div className="store-dropdowns-row flex w-full flex-wrap items-center justify-center gap-[20px] max-[767px]:w-full max-[767px]:flex-nowrap max-[767px]:items-start max-[767px]:justify-center max-[767px]:gap-[10px] max-[767px]:px-[10px] box-border">
                            <div className="store-dropdowns-buttons flex flex-row flex-wrap items-center justify-center gap-[15px] max-[767px]:flex-1 max-[767px]:flex-col max-[767px]:items-start">
                                <div className="store-sort-container flex items-center rounded-[12px] border-2 border-slider bg-bg px-[12px] py-[4px] transition-all duration-300 hover:border-primary-cyan">
                                    <span className="store-sort-label mr-[8px] whitespace-nowrap text-[0.85rem] font-[600] text-[#666]">View:</span>
                                    <select
                                        value={viewType}
                                        onChange={(e) => {
                                            setViewType(e.target.value);
                                            if (e.target.value === 'all') setSelectedCategory("");
                                        }}
                                        className="store-sort-select cursor-pointer border-none bg-transparent px-[4px] py-[2px] text-[0.9rem] font-[600] text-text outline-none"
                                    >
                                        <option value="all">All Products</option>
                                        <option value="category">Category-wise</option>
                                    </select>
                                </div>

                                {viewType === 'category' && (
                                    <div className="store-sort-container flex items-center rounded-[12px] border-2 border-slider bg-bg px-[12px] py-[4px] transition-all duration-300 hover:border-primary-cyan">
                                        <span className="store-sort-label mr-[8px] whitespace-nowrap text-[0.85rem] font-[600] text-[#666]">Category:</span>
                                        <select
                                            value={selectedCategory}
                                            onChange={(e) => setSelectedCategory(e.target.value)}
                                            className="store-sort-select cursor-pointer border-none bg-transparent px-[4px] py-[2px] text-[0.9rem] font-[600] text-text outline-none"
                                        >
                                            <option value="">Select Category</option>
                                            {uniqueCategories.map(cat => (
                                                <option key={cat} value={cat}>{cat}</option>
                                            ))}
                                            {!uniqueCategories.includes("wallpaper") && (
                                                <option value="wallpaper">Wallpaper</option>
                                            )}
                                        </select>
                                    </div>
                                )}

                                <div className="store-sort-feature-container flex items-center rounded-[12px] border-2 border-slider bg-bg px-[12px] py-[4px] transition-all duration-300 hover:border-primary-cyan">
                                    <span className="store-sort-label mr-[8px] whitespace-nowrap text-[0.85rem] font-[600] text-[#666]">Sort:</span>
                                    <select
                                        className="store-sort-select cursor-pointer border-none bg-transparent px-[4px] py-[2px] text-[0.9rem] font-[600] text-text outline-none"
                                        value={sortBy}
                                        onChange={(e) => setSortBy(e.target.value)}
                                    >
                                        <option value="name">Product Name</option>
                                    </select>
                                    <button
                                        className="store-sort-order-btn ml-[8px] flex items-center gap-[4px] border-none border-l border-slider bg-transparent pl-[10px] p-[4px] text-primary-cyan cursor-pointer"
                                        type="button"
                                        onClick={() => setSortOrder(o => o === "asc" ? "desc" : "asc")}
                                        title={sortOrder === "asc" ? "Ascending" : "Descending"}
                                    >
                                        <i className={`fi fi-rr-arrow-${sortOrder === "asc" ? "up" : "down"} text-[1rem] leading-none flex items-center`}></i>
                                        <span className="store-sort-order-letter text-[0.75rem] font-[800]">{sortOrder === "asc" ? "A" : "D"}</span>
                                    </button>
                                </div>
                            </div>

                            <div className="store-dropdowns-ad flex items-center justify-center">
                                <SidebarAd variant="store-home" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            <div className="all-product-area mx-auto grid w-full max-w-full gap-[1.5rem] p-[1.5rem] box-border">
                {all_products.length > 0 ? (
                    all_products
                ) : (
                    <div className="col-span-full p-[3rem] text-center text-[1.1rem] text-[#666]">
                        No {selectedProductType} products available
                    </div>
                )}
            </div>

            {/* Pagination */}
            {filteredProducts.length > productsPerPage && (
                <PaginationControls
                    currentPage={currentPage}
                    totalPages={totalPages}
                    containerClassName="pagination flex items-center justify-center gap-[1rem] mt-[2rem] flex-wrap"
                    buttonClassName="pagination-btn rounded-[8px] border border-slider bg-bg px-[16px] py-[8px] text-text disabled:cursor-not-allowed disabled:opacity-50 hover:bg-hover transition-colors duration-200"
                    infoClassName="page-info text-[0.95rem] font-[600] text-text"
                    previousDisabled={currentPage === 1}
                    nextDisabled={currentPage === totalPages}
                    onPrevious={() => setCurrentPage(prev => Math.max(1, prev - 1))}
                    onNext={() => setCurrentPage(prev => Math.min(totalPages, prev + 1))}
                />
            )}
        </>
    )
}
